export default function Notes({ notes }) {
  return (
    <>
      <div className="notes-bInvoice">
        <h3>Additional notes</h3>
        <p>{notes}</p>
      </div>
    </>
  )
}